import React, { FC } from 'react'
import { Main } from 'layouts'
import { Hero } from 'sections/Athletes/Hero'
import { FilterableGallery } from 'sections/Athletes/FilterableGallery'
import { BestPerformers } from 'sections/Athletes/BestPerformers/BestPerformers'
import useIsMobile from 'hooks/useIsMobile'
import { FeaturedQuote } from 'sections/Athletes/FeaturedQuote'
import { AthletesStats } from 'sections/Athletes/AthletesStats'
import { Parallax } from 'sections/Athletes/Parallax'
import { UnmatchedSleepEngineering } from 'sections/Athletes/UnmatchedSleepEngineering/UnmatchedSleepEngineering'
import { PressWithQuote } from 'components/WebEv/PressWithQuote/PressWithQuote'
import { AthletesSlider } from 'sections/Athletes/AthletesSlider/AthletesSlider'
import { PodUpsell } from 'components/PodUpsell/PodUpsell'

const galleryItems = [
	{
		name: 'Justin Medeiros',
		sport: 'CrossFit',
		category: 'CrossFit',
		country: 'USA',
		imageSrc: 'https://eightsleep.imgix.net/medeiros.jpg?v=1690396152',
		imageAlt: '',
		sources: [
			{
				mediaQuery: '(max-width: 599px)',
				src: 'https://eightsleep.imgix.net/medeiros.jpg?v=1690396152',
			},
			{
				mediaQuery: '(min-width: 600px)',
				src: 'https://eightsleep.imgix.net/medeiros.jpg?v=1690396152',
			},
		],
	},
	{
		name: 'Francisco Lindor',
		sport: 'Baseball',
		category: 'Baseball',
		country: 'USA',
		imageSrc: 'https://eightsleep.imgix.net/lindor.jpg?v=1690396152',
		imageAlt: '',
		sources: [
			{
				mediaQuery: '(max-width: 599px)',
				src: 'https://eightsleep.imgix.net/lindor.jpg?v=1690396152',
			},
			{
				mediaQuery: '(min-width: 600px)',
				src: 'https://eightsleep.imgix.net/lindor.jpg?v=1690396152',
			},
		],
	},
	{
		name: 'George Russell',
		sport: 'Racing',
		category: 'Racing',
		country: 'UK',
		imageSrc: 'https://eightsleep.imgix.net/russell.jpg?v=1690396152',
		imageAlt: '',
		sources: [
			{
				mediaQuery: '(max-width: 599px)',
				src: 'https://eightsleep.imgix.net/russell.jpg?v=1690396152',
			},
			{
				mediaQuery: '(min-width: 600px)',
				src: 'https://eightsleep.imgix.net/russell.jpg?v=1690396152',
			},
		],
	},
	{
		name: 'Taylor Fritz',
		sport: 'Tennis',
		category: 'Tennis',
		country: 'USA',
		imageSrc: 'https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/taylor-fritz-xyz.png',
		imageAlt: '',
		sources: [
			{
				mediaQuery: '(max-width: 599px)',
				src: 'https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/taylor-fritz-xyz.png',
			},
			{
				mediaQuery: '(min-width: 600px)',
				src: 'https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/taylor-fritz-xyz.png',
			},
		],
	},
	{
		name: 'Chelsea Gray',
		sport: 'Basketball',
		category: 'Basketball',
		country: 'USA',
		imageSrc: 'https://eightsleep.imgix.net/gray_683cfb51-4ba9-4562-883b-221bbacd49b6.jpg?v=1690396152',
		imageAlt: '',
		sources: [
			{
				mediaQuery: '(max-width: 599px)',
				src: 'https://eightsleep.imgix.net/gray_683cfb51-4ba9-4562-883b-221bbacd49b6.jpg?v=1690396152',
			},
			{
				mediaQuery: '(min-width: 600px)',
				src: 'https://eightsleep.imgix.net/gray_683cfb51-4ba9-4562-883b-221bbacd49b6.jpg?v=1690396152',
			},
		],
	},

	{
		name: 'Richard Carapaz',
		sport: 'Cycling',
		category: 'Cycling',
		country: 'Ecuador',
		imageSrc: 'https://eightsleep.imgix.net/carapaz.jpg?v=1690396152',
		imageAlt: '',
		sources: [
			{
				mediaQuery: '(max-width: 599px)',
				src: 'https://eightsleep.imgix.net/carapaz.jpg?v=1690396152',
			},
			{
				mediaQuery: '(min-width: 600px)',
				src: 'https://eightsleep.imgix.net/carapaz.jpg?v=1690396152',
			},
		],
	},
	{
		name: 'Sidney Crosby',
		sport: 'Ice Hockey',
		category: 'Ice Hockey',
		country: 'Canada',
		imageSrc: 'https://eightsleep.imgix.net/crosby.jpg?v=1690396152',
		imageAlt: '',
		sources: [
			{
				mediaQuery: '(max-width: 599px)',
				src: 'https://eightsleep.imgix.net/crosby.jpg?v=1690396152',
			},
			{
				mediaQuery: '(min-width: 600px)',
				src: 'https://eightsleep.imgix.net/crosby.jpg?v=1690396152',
			},
		],
	},
	{
		name: 'Patrick Peterson',
		sport: 'American Football',
		category: 'American Football',
		country: 'USA',
		imageSrc: 'https://eightsleep.imgix.net/peterson.jpg?v=1690396152',
		imageAlt: '',
		sources: [
			{
				mediaQuery: '(max-width: 599px)',
				src: 'https://eightsleep.imgix.net/peterson.jpg?v=1690396152',
			},
			{
				mediaQuery: '(min-width: 600px)',
				src: 'https://eightsleep.imgix.net/peterson.jpg?v=1690396152',
			},
		],
	},
	{
		name: 'Any Bream',
		sport: 'CrossFit',
		category: 'CrossFit',
		country: 'USA',
		imageSrc: 'https://eightsleep.imgix.net/bream.jpg?v=1690396152',
		imageAlt: '',
		sources: [
			{
				mediaQuery: '(max-width: 599px)',
				src: 'https://eightsleep.imgix.net/bream.jpg?v=1690396152',
			},
			{
				mediaQuery: '(min-width: 600px)',
				src: 'https://eightsleep.imgix.net/bream.jpg?v=1690396152',
			},
		],
	},
	{
		name: 'Chris Paul',
		sport: 'Basketball',
		category: 'Basketball',
		country: 'USA',
		imageSrc: 'https://eightsleep.imgix.net/paul.jpg?v=1690396152',
		imageAlt: '',
		sources: [
			{
				mediaQuery: '(max-width: 599px)',
				src: 'https://eightsleep.imgix.net/paul.jpg?v=1690396152',
			},
			{
				mediaQuery: '(min-width: 600px)',
				src: 'https://eightsleep.imgix.net/paul.jpg?v=1690396152',
			},
		],
	},
	{
		name: 'Rachel Neylan',
		sport: 'Cycling',
		category: 'Cycling',
		country: 'USA',
		imageSrc: 'https://eightsleep.imgix.net/neylan.jpg?v=1690396152',
		imageAlt: '',
		sources: [
			{
				mediaQuery: '(max-width: 599px)',
				src: 'https://eightsleep.imgix.net/neylan.jpg?v=1690396152',
			},
			{
				mediaQuery: '(min-width: 600px)',
				src: 'https://eightsleep.imgix.net/neylan.jpg?v=1690396152',
			},
		],
	},
	{
		name: 'Esteban Ocon',
		sport: 'Racing',
		category: 'Racing',
		country: 'France',
		imageSrc: 'https://eightsleep.imgix.net/ocon.jpg?v=1690396152',
		imageAlt: '',
		sources: [
			{
				mediaQuery: '(max-width: 599px)',
				src: 'https://eightsleep.imgix.net/ocon.jpg?v=1690396152',
			},
			{
				mediaQuery: '(min-width: 600px)',
				src: 'https://eightsleep.imgix.net/ocon.jpg?v=1690396152',
			},
		],
	},
	{
		name: 'Jordan Henderson',
		sport: 'Soccer',
		category: 'Soccer',
		country: 'UK',
		imageSrc: 'https://eightsleep.imgix.net/henderson.jpg?v=1690396152',
		imageAlt: '',
		sources: [
			{
				mediaQuery: '(max-width: 599px)',
				src: 'https://eightsleep.imgix.net/henderson.jpg?v=1690396152',
			},
			{
				mediaQuery: '(min-width: 600px)',
				src: 'https://eightsleep.imgix.net/henderson.jpg?v=1690396152',
			},
		],
	},
	{
		name: 'Ryan Murphy',
		sport: 'Swimming',
		category: 'Swimming',
		country: 'USA',
		imageSrc: 'https://eightsleep.imgix.net/murphy_61fb173d-aa95-4c80-a569-4e3507dec415.jpg?v=1690396152',
		imageAlt: '',
		sources: [
			{
				mediaQuery: '(max-width: 599px)',
				src: 'https://eightsleep.imgix.net/murphy_61fb173d-aa95-4c80-a569-4e3507dec415.jpg?v=1690396152',
			},
			{
				mediaQuery: '(min-width: 600px)',
				src: 'https://eightsleep.imgix.net/murphy_61fb173d-aa95-4c80-a569-4e3507dec415.jpg?v=1690396152',
			},
		],
	},
	{
		name: 'Travis Mayer',
		sport: 'CrossFit',
		category: 'CrossFit',
		country: 'USA',
		imageSrc: 'https://eightsleep.imgix.net/mayer.jpg?v=1690396152',
		imageAlt: '',
		sources: [
			{
				mediaQuery: '(max-width: 599px)',
				src: 'https://eightsleep.imgix.net/mayer.jpg?v=1690396152',
			},
			{
				mediaQuery: '(min-width: 600px)',
				src: 'https://eightsleep.imgix.net/mayer.jpg?v=1690396152',
			},
		],
	},
	{
		name: 'Brooke Wells',
		sport: 'CrossFit',
		category: 'CrossFit',
		country: 'USA',
		imageSrc: 'https://eightsleep.imgix.net/wells_1a1f462b-1056-44c5-b56e-27c42db48567.jpg?v=1690396152',
		imageAlt: '',
		sources: [
			{
				mediaQuery: '(max-width: 599px)',
				src: 'https://eightsleep.imgix.net/wells_1a1f462b-1056-44c5-b56e-27c42db48567.jpg?v=1690396152',
			},
			{
				mediaQuery: '(min-width: 600px)',
				src: 'https://eightsleep.imgix.net/wells_1a1f462b-1056-44c5-b56e-27c42db48567.jpg?v=1690396152',
			},
		],
	},
	{
		name: 'Cameron Wurf',
		sport: 'Triathlon',
		category: 'Triathlon',
		country: 'Australia',
		imageSrc: 'https://eightsleep.imgix.net/wurf_22bec581-5ac5-4b4a-9841-5a39a7820486.jpg?v=1690396152',
		imageAlt: '',
		sources: [
			{
				mediaQuery: '(max-width: 599px)',
				src: 'https://eightsleep.imgix.net/wurf_22bec581-5ac5-4b4a-9841-5a39a7820486.jpg?v=1690396152',
			},
			{
				mediaQuery: '(min-width: 600px)',
				src: 'https://eightsleep.imgix.net/wurf_22bec581-5ac5-4b4a-9841-5a39a7820486.jpg?v=1690396152',
			},
		],
	},
	{
		name: 'Alison Jackson',
		sport: 'Cycling',
		category: 'Cycling',
		country: 'Canada',
		imageSrc: 'https://eightsleep.imgix.net/jackson.jpg?v=1690396152',
		imageAlt: '',
		sources: [
			{
				mediaQuery: '(max-width: 599px)',
				src: 'https://eightsleep.imgix.net/jackson.jpg?v=1690396152',
			},
			{
				mediaQuery: '(min-width: 600px)',
				src: 'https://eightsleep.imgix.net/jackson.jpg?v=1690396152',
			},
		],
	},
	{
		name: 'Red Gerard',
		sport: 'Snowboarding',
		category: 'Snowboarding',
		country: 'USA',
		imageSrc: 'https://eightsleep.imgix.net/gerard.jpg?v=1690396152',
		imageAlt: '',
		sources: [
			{
				mediaQuery: '(max-width: 599px)',
				src: 'https://eightsleep.imgix.net/gerard.jpg?v=1690396152',
			},
			{
				mediaQuery: '(min-width: 600px)',
				src: 'https://eightsleep.imgix.net/gerard.jpg?v=1690396152',
			},
		],
	},
	{
		name: 'Adam Thielen',
		sport: 'American Football',
		category: 'American Football',
		country: 'USA',
		imageSrc: 'https://eightsleep.imgix.net/thielen.jpg?v=1690396152',
		imageAlt: '',
		sources: [
			{
				mediaQuery: '(max-width: 599px)',
				src: 'https://eightsleep.imgix.net/thielen.jpg?v=1690396152',
			},
			{
				mediaQuery: '(min-width: 600px)',
				src: 'https://eightsleep.imgix.net/thielen.jpg?v=1690396152',
			},
		],
	},
	{
		name: 'Trevoh Chalobah',
		sport: 'Soccer',
		category: 'Soccer',
		country: 'UK',
		imageSrc: 'https://eightsleep.imgix.net/chalobah.jpg?v=1690396152',
		imageAlt: '',
		sources: [
			{
				mediaQuery: '(max-width: 599px)',
				src: 'https://eightsleep.imgix.net/chalobah.jpg?v=1690396152',
			},
			{
				mediaQuery: '(min-width: 600px)',
				src: 'https://eightsleep.imgix.net/chalobah.jpg?v=1690396152',
			},
		],
	},
	{
		name: 'Danny Green',
		sport: 'Basketball',
		category: 'Basketball',
		country: 'USA',
		imageSrc: 'https://eightsleep.imgix.net/green.jpg?v=1690396152',
		imageAlt: '',
		sources: [
			{
				mediaQuery: '(max-width: 599px)',
				src: 'https://eightsleep.imgix.net/green.jpg?v=1690396152',
			},
			{
				mediaQuery: '(min-width: 600px)',
				src: 'https://eightsleep.imgix.net/green.jpg?v=1690396152',
			},
		],
	},
	{
		name: 'Caroline Conners',
		sport: 'CrossFit',
		category: 'CrossFit',
		country: 'USA',
		imageSrc: 'https://eightsleep.imgix.net/conners.jpg?v=1690396152',
		imageAlt: '',
		sources: [
			{
				mediaQuery: '(max-width: 599px)',
				src: 'https://eightsleep.imgix.net/conners.jpg?v=1690396152',
			},
			{
				mediaQuery: '(min-width: 600px)',
				src: 'https://eightsleep.imgix.net/conners.jpg?v=1690396152',
			},
		],
	},
	{
		name: 'Rigoberto Urán',
		sport: 'Cycling',
		category: 'Cycling',
		country: 'Colombia',
		imageSrc: 'https://eightsleep.imgix.net/uran.jpg?v=1690396152',
		imageAlt: '',
		sources: [
			{
				mediaQuery: '(max-width: 599px)',
				src: 'https://eightsleep.imgix.net/uran.jpg?v=1690396152',
			},
			{
				mediaQuery: '(min-width: 600px)',
				src: 'https://eightsleep.imgix.net/uran.jpg?v=1690396152',
			},
		],
	},
	{
		name: 'Kristie O’Connell',
		sport: 'CrossFit',
		category: 'CrossFit',
		country: 'USA',
		imageSrc: 'https://eightsleep.imgix.net/o_connell.jpg?v=1690396152',
		imageAlt: '',
		sources: [
			{
				mediaQuery: '(max-width: 599px)',
				src: 'https://eightsleep.imgix.net/o_connell.jpg?v=1690396152',
			},
			{
				mediaQuery: '(min-width: 600px)',
				src: 'https://eightsleep.imgix.net/o_connell.jpg?v=1690396152',
			},
		],
	},
	{
		name: 'Johnny Collinson',
		sport: 'Skiing',
		category: 'Skiing',
		country: 'USA',
		imageSrc: 'https://eightsleep.imgix.net/collinson.jpg?v=1690396152',
		imageAlt: '',
		sources: [
			{
				mediaQuery: '(max-width: 599px)',
				src: 'https://eightsleep.imgix.net/collinson.jpg?v=1690396152',
			},
			{
				mediaQuery: '(min-width: 600px)',
				src: 'https://eightsleep.imgix.net/collinson.jpg?v=1690396152',
			},
		],
	},
	{
		name: 'Dan Ige',
		sport: 'Mixed Martial Arts',
		category: 'Mixed Martial Arts',
		country: 'USA',
		imageSrc: 'https://eightsleep.imgix.net/ige.jpg?v=1690396152',
		imageAlt: '',
		sources: [
			{
				mediaQuery: '(max-width: 599px)',
				src: 'https://eightsleep.imgix.net/ige.jpg?v=1690396152',
			},
			{
				mediaQuery: '(min-width: 600px)',
				src: 'https://eightsleep.imgix.net/ige.jpg?v=1690396152',
			},
		],
	},
	{
		name: 'Baylee Rayl',
		sport: 'CrossFit',
		category: 'CrossFit',
		country: 'USA',
		imageSrc: 'https://eightsleep.imgix.net/rayl.jpg?v=1690396152',
		imageAlt: '',
		sources: [
			{
				mediaQuery: '(max-width: 599px)',
				src: 'https://eightsleep.imgix.net/rayl.jpg?v=1690396152',
			},
			{
				mediaQuery: '(min-width: 600px)',
				src: 'https://eightsleep.imgix.net/rayl.jpg?v=1690396152',
			},
		],
	},
	{
		name: 'Juan Manuel Correa',
		sport: 'Racing',
		category: 'Racing',
		country: 'USA',
		imageSrc: 'https://eightsleep.imgix.net/correa.jpg?v=1690396152',
		imageAlt: '',
		sources: [
			{
				mediaQuery: '(max-width: 599px)',
				src: 'https://eightsleep.imgix.net/correa.jpg?v=1690396152',
			},
			{
				mediaQuery: '(min-width: 600px)',
				src: 'https://eightsleep.imgix.net/correa.jpg?v=1690396152',
			},
		],
	},
	{
		name: 'Neilson Powless',
		sport: 'Cycling',
		category: 'Cycling',
		country: 'USA',
		imageSrc: 'https://eightsleep.imgix.net/powless.jpg?v=1690396152',
		imageAlt: '',
		sources: [
			{
				mediaQuery: '(max-width: 599px)',
				src: 'https://eightsleep.imgix.net/powless.jpg?v=1690396152',
			},
			{
				mediaQuery: '(min-width: 600px)',
				src: 'https://eightsleep.imgix.net/powless.jpg?v=1690396152',
			},
		],
	},
	{
		name: 'Leah Irons',
		sport: 'CrossFit',
		category: 'CrossFit',
		country: 'USA',
		imageSrc: 'https://eightsleep.imgix.net/irons.jpg?v=1690396152',
		imageAlt: '',
		sources: [
			{
				mediaQuery: '(max-width: 599px)',
				src: 'https://eightsleep.imgix.net/irons.jpg?v=1690396152',
			},
			{
				mediaQuery: '(min-width: 600px)',
				src: 'https://eightsleep.imgix.net/irons.jpg?v=1690396152',
			},
		],
	},
	{
		name: 'Kieran Reilly',
		sport: 'BMX',
		category: 'BMX',
		country: 'UK',
		imageSrc: 'https://eightsleep.imgix.net/reilly.jpg?v=1690395636',
		imageAlt: '',
		sources: [
			{
				mediaQuery: '(max-width: 599px)',
				src: 'https://eightsleep.imgix.net/reilly.jpg?v=1690395636',
			},
			{
				mediaQuery: '(min-width: 600px)',
				src: 'https://eightsleep.imgix.net/reilly.jpg?v=1690395636',
			},
		],
	},
	{
		name: 'Griffin Roelle',
		sport: 'CrossFit',
		category: 'CrossFit',
		country: 'USA',
		imageSrc: 'https://eightsleep.imgix.net/roelle.jpg?v=1690395636',
		imageAlt: '',
		sources: [
			{
				mediaQuery: '(max-width: 599px)',
				src: 'https://eightsleep.imgix.net/roelle.jpg?v=1690395636',
			},
			{
				mediaQuery: '(min-width: 600px)',
				src: 'https://eightsleep.imgix.net/roelle.jpg?v=1690395636',
			},
		],
	},
]

const Athletes: FC = () => {
	const isMobile = useIsMobile(600)
	const videoSrc = isMobile
		? 'https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/5e0c6a1351864a8db9912b50d6ab5d13.mp4'
		: 'https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/78c8a56e4a0748eda5e589e57a183e7c.mp4'
	return (
		<Main>
			<Hero />
			<UnmatchedSleepEngineering />
			<BestPerformers />
			<AthletesSlider />

			<section>
				<AthletesStats />
			</section>

			<section>
				<FilterableGallery items={galleryItems} />
			</section>

			<section
				className={'inner-paddings-x inner-paddings-y bg-white'}
				id={'awards'}
			>
				<PressWithQuote />
			</section>

			<section>
				<Parallax />
			</section>

			<section className="inner-paddings-top inner-paddings-bottom">
				<FeaturedQuote />
			</section>

			<PodUpsell />
		</Main>
	)
}

export default Athletes
